if (!customElements.get('f52-contact-hub')) {
  class F52ContactHub extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-f52-contact-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-f52-contact-panel]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index, true));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      this.onBlockSelect = (event) => {
        const panel = event.target.closest?.('[data-f52-contact-panel]');
        if (!panel || !this.contains(panel)) return;

        const index = this.panels.indexOf(panel);
        if (index >= 0) this.activate(index);
      };

      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.activate(0);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    activate(index, moveFocus = false) {
      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((panel, panelIndex) => {
        const active = panelIndex === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });

      if (moveFocus) this.tabs[index]?.focus();
    }

    onKeydown(event, index) {
      let nextIndex;

      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        nextIndex = (index + 1) % this.tabs.length;
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.activate(nextIndex, true);
    }
  }

  customElements.define('f52-contact-hub', F52ContactHub);
}
